import { createStore } from "vuex";
import writeupsModule from './writeups/index.js'


const store = createStore({
    modules: {
        writeups: writeupsModule
    }
});

export default store;